type SceneData = Record<string, unknown>;

/**
 * Restore customBgs from resolved layers when an older server omits that field.
 * A server that already returns customBgs stays authoritative.
 */
export function restoreLayeredCustomBgs(
  sceneData: SceneData | null,
  layers: Array<SceneData | null | undefined>
): SceneData | null {
  if (sceneData?.customBgs !== undefined) return sceneData;

  const customBgsLayers = layers
    .map((layer) => layer?.customBgs)
    .filter(
      (value): value is Record<string, unknown> =>
        value !== null && typeof value === "object" && !Array.isArray(value)
    );
  if (customBgsLayers.length === 0) return sceneData;

  return {
    ...(sceneData ?? {}),
    customBgs: Object.assign({}, ...customBgsLayers),
  };
}
